import { Component } from '@angular/core';
import { HomeBestSellers } from '../../components/home/home-best-sellers/home-best-sellers';
import { HomeCarousel } from '../../components/home/home-carousel/home-carousel';
import { HomeNewArrivals } from '../../components/home/home-new-arrivals/home-new-arrivals';
import { HomeProductsBanner } from '../../components/home/home-products-banner/home-products-banner';
import { HomeWelcome } from '../../components/home/home-welcome/home-welcome';
import { TitleService } from '../../services/title.service';
@Component({
  selector: 'app-home-page',
  imports: [
    HomeCarousel,
    HomeNewArrivals,
    HomeBestSellers,
    HomeWelcome,
    HomeProductsBanner,
  ],
  templateUrl: './home-page.html',
  styleUrl: './home-page.scss',
})
export class HomePage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('');
  }
}
